import React , {useState,useEffect}from 'react';
import classes from './PersonalProjects.css';
import Project from '../../Project/Project';
import Container from '../../../hoc/Container/Container';
import CardContainer from '../../../hoc/CardContainer/CardContainer';
import axios from '../../../firebase-axios';
const personalProjects = () => {
  const [state,setState] = useState({projects:[]});
  let projectList = [];
  useEffect(() => {
    axios.get('personalProjects.json')
    .then((res) => {
        const resList = [];
        for(const key in res.data) {
            resList.push({
                id:key,
                ...res.data[key]
            });
        }
        setState({projects:resList});
    })
    .catch((err) => {
        alert('Something went wrong');
        console.log(err);
    })
  },[]);

  if(state.projects.length != 0) {
    projectList = state.projects.map((data) => {
        return (<Project key={data.id} name={data.name} github={data.github} online={data.online} pariority={data.pariority} posterImage={data.posterImage} technologies={data.technologies} description={data.description} />);
    });
  }
  return (<section id="personalProjects" className={classes.projects+' bg-projects'}  >
        <h2 className="site-section-title">Personal Projects</h2>
    <Container>
        <CardContainer>
            {projectList}
        </CardContainer>
    </Container>
</section>)
};

export default personalProjects;


// WEBPACK FOOTER //
// ./src/components/Sections/PersonalProjects/PersonalProjects.js